export default __webpack_public_path__ + "static/media/Snd_TryX.729cafdb.mp3";